// 模块-枚举

/**
 * 主页模块
 * @type {string}
 */
export const HOME = 'ai/d/m/home'
/**
 * 创意绘图(基础版)
 * @type {string}
 */
export const M_BASIC = 'ai/d/m/basic'
/**
 * 创意绘图(高级版)
 * @type {string}
 */
export const M_ADVANCED = 'ai/d/m/advanced'
/**
 * 文生图(基础版)
 * @type {string}
 */
export const T_BASIC_TTI = 'ai/d/t/basicTti'
/**
 * 图生图(基础版)
 * @type {string}
 */
export const T_BASIC_ITI = 'ai/d/t/basicIti'
/**
 * 文生图(SD)
 * @type {string}
 */
export const T_SD_TTI = 'ai/d/t/sdTti'
/**
 * 图生图(SD)
 * @type {string}
 */
export const T_SD_ITI = 'ai/d/t/sdIti'
/**
 * 文生图(Flux)
 * @type {string}
 */
export const T_FLUX_TTI = 'ai/d/t/fluxTti'
/**
 * 图生图(Flux)
 * @type {string}
 */
export const T_FLUX_ITI = 'ai/d/t/fluxIti'
/**
 * 智能抠图
 * @type {string}
 */
export const T_BACKGROUND_REMOVE = 'ai/d/t/backgroundRemove'
/**
 * 智能扩图
 * @type {string}
 */
export const T_IMAGE_SCALING = 'ai/d/t/imagScaling'
/**
 * AI超清
 * @type {string}
 */
export const T_QUALITY_OPT = 'ai/d/t/qualityOpt'

/**
 * 色卡修图
 * @type {string}
 */
export const T_COLOR_CARD_RETouchING = 'ai/d/t/colorCardRetouching'

/**
 * 产品精修（nano banana pro）
 * @type {string}
 */
export const Product_Retouch = 'ai/d/t/ProductRetouch'

/**
 * 视频生成
 * @type {string}
 */
export const VIDEO_GENERATION = 'ai/d/t/videoGeneration'

/**
 * 视频脚本反推
 * @type {string}
 */
export const VIDEO_SCRIPT_RETRIEVAL = 'ai/d/t/videoScriptRetrieval'

/**
 * 视频音效
 * @type {string}
 */
export const VIDEO_SOUND = 'ai/d/t/videoSound'

/**
 * 视频剪辑
 * @type {string}
 */
export const VIDEO_CLIP = 'ai/d/t/videoClip'

/**
 * 多角度生成
 * @type {string}
 */
export const MULTI_ANGLE = 'ai/d/t/multiAngle'

/**
 * 局部重绘
 * @type {string}
 */
export const LOCAL_REPAINT = 'ai/d/t/localRepaint'

// 新增加功能命名 ==============================================================================================================================================
/**
 * 智能消除
 * @type {string}
 */
export const AI_REMOVE_CONTAINER = 'ai/d/t/removeContainer'

/**
 * 智能抠图V2
 * @type {string}
 */
export const AI_MATTING_V2 = 'ai/d/t/mattingV2'

/**
 * 视频抠像
 * @type {string}
 */
export const VIDEO_MATTING = 'ai/d/t/videoMatting'

/**
 * 视频放大
 * @type {string}
 */
export const VIDEO_UPSCALE = 'ai/d/t/videoUpscale'

/**
 * GPT-40
 * @type {string}
 */
export const GPT_4_0 = 'ai/d/t/gpt40'

/**
 * KontextV1
 * @type {string}
 */
export const KONTEXT_V1 = 'ai/d/t/kongTextv1'

/**
 * KontextV2
 * @type {string}
 */
export const KONTEXT_V2 = 'ai/d/t/kongTextv2'

/**
 * 更换甲片-基础
 * @type {string}
 */
export const CHANGE_FINGER_V1 = 'ai/d/t/changeFingerv1'

/**
 * 更换甲片-甲型甲款
 * @type {string}
 */
export const CHANGE_FINGER_V2 = 'ai/d/t/changeFingerv2'

/**
 * PS图像调整
 * @type {string}
 */
export const EDIT_Image_PS = 'ai/d/t/editImageps'

/**
 * 手部修复
 * @type {string}
 */
export const HANDS_RECOVER = 'ai/d/t/handsrecover'

/**
 * 局部重绘
 * @type {string}
 */
export const PARTIAL_REDRAW = 'ai/d/t/partialredraw'

/**
 * 万物迁移
 * @type {string}
 */
export const UNIVERSAL_MIGRATE = 'ai/d/t/universalmigrate'

/**
 * 产品拼接
 * @type {string}
 */
export const PRODUCT_SPLICING = 'ai/d/t/productSplicing'

/**
 * 光影溶图
 * @type {string}
 */
export const T_BLEND_IMAGE = 'ai/d/t/blendImage'

/**
 * 甲片迁移
 * @type {string}
 */
export const NAIL_TIP_TRANSFER = 'ai/d/t/nailTipTransfer'

/**
 * Pandora魔盒
 * @type {string}
 */
export const Pandora = 'ai/d/t/pandora'

// 增加一个功能函数 ==================================================================================

function makeArray(len, name) {
  const array = []
  for (let i = 0; i < len; i++) {
    array.push(`${name}${i + 1}`)
  }
  return array
}

// 创建一堆数组
const MODEL_List = makeArray(4, 'ai/d/t/modelGen')
const POSTER_List = makeArray(13, 'ai/d/t/posterGen')
const HAND_List = makeArray(14, 'ai/d/t/handGen')
// console.log(MODEL_List, POSTER_List, HAND_List)

export {
  MODEL_List,
  POSTER_List,
  HAND_List
}

export const COMMAND_MODULES_MAP = [
  {
    desc: '创意绘图(基础版)',
    value: M_BASIC
  },
  {
    desc: '创意绘图(高级版)',
    value: M_ADVANCED
  },
  {
    desc: '文生图(基础版)',
    value: T_BASIC_TTI
  },
  {
    desc: '图生图(基础版)',
    value: T_BASIC_ITI
  },
  {
    desc: '文生图(SD)',
    value: T_SD_TTI
  },
  {
    desc: '图生图(SD)',
    value: T_SD_ITI
  },
  {
    desc: '文生图(Flux)',
    value: T_FLUX_TTI
  },
  {
    desc: '图生图(Flux)',
    value: T_FLUX_ITI
  },
  {
    desc: '智能抠图',
    value: T_BACKGROUND_REMOVE
  },
  {
    desc: '智能扩图',
    value: T_IMAGE_SCALING
  },
  {
    desc: 'AI超清',
    value: T_QUALITY_OPT
  },
  {
    desc: '智能抠图V2',
    value: AI_MATTING_V2
  },
  {
    desc: '视频抠像',
    value: VIDEO_MATTING
  },
  {
    desc: '视频放大',
    value: VIDEO_UPSCALE
  },
  {
    desc: 'Kontext编辑V1',
    value: KONTEXT_V1
  },
  {
    desc: 'Kontext编辑V2',
    value: KONTEXT_V2
  },
  {
    desc: '更换甲片V1',
    value: CHANGE_FINGER_V1
  },
  {
    desc: '更换甲片-甲型甲款',
    value: CHANGE_FINGER_V2
  },
  {
    desc: '手部修复',
    value: HANDS_RECOVER
  },
  {
    desc: '色卡修图',
    value: T_COLOR_CARD_RETouchING
  },
  {
    desc: '产品精修(Nano Banana Pro)',
    value: Product_Retouch
  },
  {
    desc: '视频生成',
    value: VIDEO_GENERATION
  },
  {
    desc: '视频脚本反推',
    value: VIDEO_SCRIPT_RETRIEVAL
  },
  {
    desc: '视频音效',
    value: VIDEO_SOUND
  },
  {
    desc: '多角度生成',
    value: MULTI_ANGLE
  },
  {
    desc: '局部重绘',
    value: PARTIAL_REDRAW
  },
  {
    desc: '万物迁移',
    value: UNIVERSAL_MIGRATE
  },
  {
    desc: '光影溶图',
    value: T_BLEND_IMAGE
  },
  {
    desc: '甲片迁移',
    value: NAIL_TIP_TRANSFER
  }
  // {
  //   desc: '美甲生成',
  //   value: FINGERNAIL_G
  // },
  // {
  //   desc: '手图生成',
  //   value: HANDGENERATE
  // },
  // {
  //   desc: '海报生成',
  //   value: POSTER_GEN
  // },
  // {
  //   desc: '模特生成',
  //   value: MODEL_GEN
  // }
]
